export default "__VITE_ASSET__BqNsLW_f__"